import { useEffect, useState } from "react";
import { getAxiosInstance } from "../../../utils/axiosInstance";
import { FormControl, FormLabel } from "@chakra-ui/react";
import { Select } from "chakra-react-select";
import { useTranslation } from "react-i18next";

interface AddProvider {
  selectedProvider: string;
  setSelectedProvider: (value: string) => void;
}

const AddProvider = (props: AddProvider) => {
  const {
    selectedProvider,
    setSelectedProvider
  } = props;

  const { t } = useTranslation("translations");
  const [name, setName] = useState<string>("");
  const [formattedProviderList, setFormattedProviderList] = useState<{value: string, label: string, colorScheme: string}[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchProvider = async (name: string) => {
    setIsLoading(true);
    try {
      const res = await getAxiosInstance().get(`/Providers/ByName/${name.length > 0 ? name : null}`);
      setFormattedProviderList(res.data.map((x: any) => ({ value: x.id, label: x.name, colorScheme: "yellow"})))
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (name.length > 0) fetchProvider(name).then(() => {});
  }, [name]);

  return (
    <FormControl>
      <FormLabel>{t("SELECT_PROVIDER")}</FormLabel>
      <Select
        isRequired
        name={t("SELECT_PROVIDER")}
        options={formattedProviderList}
        value={formattedProviderList.findIndex(x => x.value === selectedProvider) != -1 ? formattedProviderList[formattedProviderList.findIndex(x => x.value === selectedProvider)] : null}
        tagVariant="solid"
        placeholder={t("SELECT_PROVIDER_PLACEHOLDER")}
        onInputChange={(e) => setName(e)}
        inputValue={name}
        onChange={(e) => {
          if(e) setSelectedProvider(e.value);
        }}
        isLoading={isLoading}
      />
    </FormControl>
  );
};

export default AddProvider;
